'use client';

import { type ReactNode } from 'react';
import ItemCollectionContainer, {
	type ItemCollectionContainerProps,
} from 'components/containers/item-collection-container';

const Shelf = ({
	as = 'div',
	gap = 'var(--spacing-xxs)',
	isRightToLeft = false,
	autoSizeItems = false,
	autoSizedVisibleItemCount = 2,
	hasClampedWidth = false,
	className,
	children,
}: ShelfProps) => {
	return (
		<ItemCollectionContainer
			type="shelf"
			as={as}
			gap={gap}
			shelfOptions={{
				isRightToLeft,
				autoSizeItems,
				autoSizedVisibleItemCount,
				hasClampedWidth,
			}}
			className={className}
		>
			{children}
		</ItemCollectionContainer>
	);
};

type ShelfOptions = ItemCollectionContainerProps['shelfOptions'];

export interface ShelfProps {
	as?: ItemCollectionContainerProps['as'];
	gap?: ItemCollectionContainerProps['gap'];
	isRightToLeft?: ShelfOptions['isRightToLeft'];
	autoSizeItems?: ShelfOptions['autoSizeItems'];
	autoSizedVisibleItemCount?: ShelfOptions['autoSizedVisibleItemCount'];
	hasClampedWidth?: ShelfOptions['hasClampedWidth'];
	className?: ItemCollectionContainerProps['className'];
	children: ReactNode;
}

export default Shelf;
